// extracted by mini-css-extract-plugin
module.exports = {"Inner":"styles-module--Inner--1C9d-","MediaIcons":"styles-module--MediaIcons--l83Ek"};